import classNames from 'classnames';

import styles from './full-height-wrapper.module.scss';
import { useInnerHeight } from '../../../global/hooks/use-inner-height';

type FullHeightWrapperProps = {
  className?: string;
  children?: React.ReactNode;
  scrollable?: boolean;
};

/**
 * Creates a wrapper that will expand to 100VH of the screen, this is useful when 100vh is
 * needed but avoids the problems with vertical viewport units on mobile, where
 * the toolbars in browsers do not change vh values even though they take up screen space.
 */
export const FullHeightWrapper = ({
  className,
  children,
  scrollable,
}: FullHeightWrapperProps) => {
  const [height] = useInnerHeight();
  return (
    <div
      style={{ height }}
      className={classNames(
        className,
        styles['full-height-wrapper'],
        scrollable && styles['full-height-wrapper--scrollable'],
      )}
    >
      {children}
    </div>
  );
};
